import React from "react";
import { useLocation } from "react-router-dom";
import FlightCard from "./MultiFlightCard";

const MultiFlightResults = () => {
    const location = useLocation();
    const { flightsData, searchDetails } = location.state || {};

    const MultiFlightResults = flightsData?.Response?.Results?.[0] || [];
    console.log("Flights Data:", flightsData);
    console.log("traceid", flightsData?.Response?.TraceId);
    const traceId = flightsData?.Response?.TraceId || "No Trace ID";
    const resultIndex = flightsData?.Response?.Results ;
    console.log("MultiFlightResults:", MultiFlightResults);
    console.log("Search Details:", searchDetails);
    console.log("Trace ID:", traceId);
    console.log("Result Index:", resultIndex);
    return (
        <div>
            {MultiFlightResults.map((flight, index) => (
                <FlightCard key={index} flight={flight} searchDetails={searchDetails} resultIndex={resultIndex} traceId={traceId} />
            ))}
        </div>
    );
};

export default MultiFlightResults;
